import api from "../../APIIntercepter";

async function getCoursesAdminAPI() {
  const res = await api.get("/course/admin");
  return res.data;
}

async function createCourseAPI(params) {
  const res = await api.post("/course/admin", params);
  return res.data;
}

async function updateCourseAPI(params) {
  const res = await api.put("/course/admin", params);
  return res.data;
}

async function deleteCourseAPI(courseId) {
  const res = await api.delete("/course/admin/" + courseId);
  return res.data;
}

async function getCourseFilesAPI(courseId) {
  const res = await api.get("/coursedetails?id=" + courseId);
  return res.data;
}

async function createCourseFilesAPI(params) {
  const res = await api.post("/coursedetails/admin", params);
  return res.data;
}

async function updateCourseFilesAPI(params) {
  const res = await api.put("/coursedetails/admin", params);
  return res.data;
}

async function deleteCourseFilesAPI(id) {
  const res = await api.delete("/coursedetails/admin?id=" + id);
  return res.data;
}

async function getCourseStudentsAPI(courseId) {
  const res = await api.get("/studentcourseassign/admin/getStudentInformation/" + courseId + "/2");
  return res.data;
}

async function assignCourseStudentAPI(params) {
  const res = await api.post("/studentcourseassign/admin", params);
  return res.data;
}

async function removeCourseStudentAPI(id) {
  const res = await api.post("/studentcourseassign/admin/unassign/" + id);
  return res.data;
}

export {
  getCoursesAdminAPI,
  createCourseAPI,
  updateCourseAPI,
  deleteCourseAPI,
  getCourseFilesAPI,
  createCourseFilesAPI,
  updateCourseFilesAPI,
  deleteCourseFilesAPI,
  getCourseStudentsAPI,
  assignCourseStudentAPI,
  removeCourseStudentAPI,
};
